import { Badge, BadgeVariant } from '@/components/ui/badge';
import { cn } from "@/lib/utils";

export type CreatedFrom = 'checkoutSession' | 'manual' | 'upsellSession' | 'rebill' | 'subscription';

export interface CreatedFromBadgeProps {
  createdFrom: string;
  className?: string;
}

// Get badge variant based on order source
const getCreatedFromBadgeVariant = (createdFrom: string): BadgeVariant => {
  const normalizedSource = createdFrom?.toLowerCase() || '';

  // Checkout sessions (primary flow)
  if (normalizedSource.includes('checkout')) return 'blue';

  // Upsells (conversion optimization)
  if (normalizedSource.includes('upsell')) return 'orange';

  // Subscription rebills (recurring)
  if (normalizedSource.includes('rebill') || normalizedSource.includes('subscription')) return 'green';

  // Manual orders (admin created)
  if (normalizedSource === 'manual') return 'gray';

  return 'gray';
};

// Get display label for order source
const getCreatedFromLabel = (createdFrom: string): string => {
  const normalizedSource = createdFrom?.toLowerCase() || '';

  const sourceMap: Record<string, string> = {
    checkoutsession: 'Checkout',
    manual: 'Manual',
    upsellsession: 'Upsell',
    rebill: 'Rebill',
    subscription: 'Subscription',
  };

  return sourceMap[normalizedSource] || createdFrom;
};

export function CreatedFromBadge({ createdFrom, className }: CreatedFromBadgeProps) {
  return (
    <Badge variant={getCreatedFromBadgeVariant(createdFrom)} className={cn('min-w-[72px] justify-center', className)}>
      {getCreatedFromLabel(createdFrom)}
    </Badge>
  );
}
